<template>
  <modal-base
    ref="modalDefault"
    :title="title"
    :subtitle="subtitle"
    :width="width"
    :is-double-column="isDoubleColumn"
    :is-triple-column="isTripleColumn"
    :is-wide="isWide"
    :on-close-clear-query="onCloseClearQuery"
    :hide-close-button="hideCloseButton"
    @close="emitClosed"
  >
    <div :class="['modal-inner', {'no_padding': noPadding}]">
      <slot></slot>
    </div>

    <template v-slot:footer>
      <slot name="footer"></slot>
    </template>
  </modal-base>
</template>

<script>
import ModalBase from "./ModalBase";

export default {
  name: "ModalDefault",
  components: { ModalBase },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: String,
    width: {
      type: Number,
    },
    isDoubleColumn: {
      type: Boolean,
      default: false
    },
    isTripleColumn: {
      type: Boolean,
      default: false
    },
    isWide: {
      type: Boolean,
      default: false
    },
    onCloseClearQuery: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    open() {
      this.$refs.modalDefault.open();
      this.$emit('open')
    },
    emitClosed() {
      this.$emit('close');
    },
    close() {
      this.$refs.modalDefault.close();
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.modal-inner {
  padding: $defaultGap;
  background-color: $white;

  &.no_padding {
    padding: 0;
  }
}
</style>
